// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle__3gbQr","ToggleWrapper":"Toggle_ToggleWrapper__3kYWc","FadeIn":"Toggle_FadeIn__f8hz1","MenuToggle":"Toggle_MenuToggle__2eTMB"};